import { render, staticRenderFns } from "./attestDetails.vue?vue&type=template&id=5e2df898&scoped=true&"
import script from "./attestDetails.vue?vue&type=script&lang=js&"
export * from "./attestDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2df898",
  null
  
)

export default component.exports